import './styles/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import 'material-design-icons-iconfont/dist/material-design-icons.min.css'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './config/vuestic-ui/global-config'

// 导入字体加载器
import { fontLoader, PROJECT_FONTS } from './utils/fontLoader'
import { initFontAnalysis } from './utils/fontSubset'

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

// 应用挂载前预加载字体
Promise.all([
  fontLoader.preloadFonts(PROJECT_FONTS),
  new Promise((resolve) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve)
    } else {
      resolve(void 0)
    }
  }),
])
  .then(() => {
    console.log('字体预加载完成，已加载的字体:', fontLoader.getLoadedFonts())
  })
  .catch((error) => {
    console.warn('字体预加载过程中出现错误:', error)
  })
  .finally(() => {
    app.mount('#app')

    // 开发环境初始化字体分析工具
    initFontAnalysis()
  })
